import styled from "styled-components";
import {Col} from "react-bootstrap";


export const ButtonGroup = styled(Col)`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`
